import type { LogisticStatusEnum } from '../../logistic/LogisticStatusEnum'
import { UpdateProductInventoryItemArgs } from './UpdateProductInventoryItemArgs'
import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs, type IAction } from '../../action'
import type { Logistic } from '../../logistic'

@InputType()
export class UpdateProductInventoryArgs extends ActionArgs {
  @Field(() => ID)
  documentId: string

  @Field(() => [UpdateProductInventoryItemArgs])
  items: UpdateProductInventoryItemArgs[]

  @Field(() => String)
  status?: LogisticStatusEnum
}

export interface IUpdateProductInventory extends IAction<Logistic, UpdateProductInventoryArgs> {}
